import { render, staticRenderFns } from "./competition-record.vue?vue&type=template&id=81521778&scoped=true"
import script from "./competition-record.vue?vue&type=script&lang=js"
export * from "./competition-record.vue?vue&type=script&lang=js"
import style0 from "./competition-record.vue?vue&type=style&index=0&id=81521778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81521778",
  null
  
)

export default component.exports